import Vue from 'vue'
import Numeral from 'numeral'
import moment from 'moment'

export function setAppLanguage (store, i18n, lang) {
  return store.dispatch('setLanguage', lang)
    .then(() => {
      Vue.$log.debug('setAppLanguage ok + ' + store.state.language)
      i18n.locale = lang
      Numeral.locale(lang)
      moment.locale(lang)
    })
    .catch(function (error) {
      Vue.$log.debug('setAppLanguage error ' + error)
    })
}
